import { create } from 'zustand';
import { getScan, ScanModel } from '../../network';
import { SourceId } from '../CanvasView/CanvasView';

export enum CompareModeEnum {
  Single = 'single',
  Dual = 'dual',
}

type ScanSelectorState = SourceId | null;

interface CompareStore {
  compareMode: CompareModeEnum;
  setCompareMode: (mode: CompareModeEnum) => void;
  leftScan: ScanModel | null;
  rightScan: ScanModel | null;
  setLeftScan: (scanId: string | number | null) => void;
  setRightScan: (scanId: string | number | null) => void;
  isScanSelectorOpen: ScanSelectorState;
  setIsScanSelectorOpen: (sourceId: ScanSelectorState) => void;
  isLoading: boolean;
  error: Error | null;
}

export const useCompareStore = create<CompareStore>((set) => {
  const loadScan = async (scanId: string | number | null) => {
    if (!scanId) {
      return null;
    }

    try {
      set({ isLoading: true });
      return await getScan(scanId);
    } catch (error) {
      console.error(error);
      set({ error: error as Error });
      return null;
    } finally {
      set({ isLoading: false });
    }
  };

  const setScan = async (
    scanId: string | number | null,
    targetSide: SourceId
  ) => {
    set({ isScanSelectorOpen: null });
    const scan = await loadScan(scanId);
    if (targetSide === 'primary') {
      set({ leftScan: scan });
      return;
    }

    if (targetSide === 'secondary') {
      set({ rightScan: scan });
      return;
    }
  };

  return {
    compareMode: CompareModeEnum.Single,
    setCompareMode: (mode: CompareModeEnum) => set({ compareMode: mode }),
    leftScan: null,
    rightScan: null,
    isLoading: false,
    setLeftScan: async (scanId) => {
      await setScan(scanId, 'primary');
    },
    setRightScan: async (scanId) => {
      await setScan(scanId, 'secondary');
    },
    isScanSelectorOpen: null,
    setIsScanSelectorOpen: (sourceId) => set({ isScanSelectorOpen: sourceId }),
    error: null,
  };
});
